import { useState, useEffect } from "react";
import config from "../../utils/config";
import { toast } from "react-toastify";
import { ImageValidation } from "../Validation/ImageValidation";
import Rejectreason from "./Rejectreason";
import { useKycPanVerifyMutation } from "../../redux/kycApi";

const { imageUrl } = config;

const Pancard = ({ kycTrack, refetch }) => {
  const [image, setImage] = useState("/assets/img/icon2.png");
  const [panNumber, setPanNumber] = useState("");
  const [panNumberError, setPanNumberError] = useState("");
  const [panImageStatus, setPanImageStatus] = useState("0");
  const [pancardImage, setPancardImage] = useState("");
  const [pancardImageShow, setPancardImageShow] = useState("");
  const [pancardImageError, setPancardImageError] = useState("");
  const [rejectionReason, setRejectionReason] = useState("");
  const [btnDisable, setBtnDisable] = useState(false);
  const [kycPanVerify] = useKycPanVerifyMutation();

  const status = kycTrack?.progress?.pan_verification?.status;
  const isEditable = status === "pending" || status === "rejected";

  useEffect(() => {
    const panDetails = kycTrack?.progress?.pan_verification?.data;

    const loadImageAsFile = async (url, filename = "pan.jpg") => {
      try {
        const res = await fetch(url);
        const blob = await res.blob();
        return new File([blob], filename, { type: blob.type });
      } catch (err) {
        console.error("Failed to convert PAN image URL to File:", err);
        return null;
      }
    };

    if (panDetails) {
      const url = imageUrl + "/" + panDetails.image;

      setImage(url);
      setPanNumber(panDetails.pan_number || "");
      setPanImageStatus(
        kycTrack?.progress?.pan_verification?.status || "pending"
      );
      setRejectionReason(panDetails.reason || "");

      // 👇 Convert preview URL → File object so submit works
      loadImageAsFile(url, "pancard.jpg").then((file) => {
        if (file) setPancardImage(file);
      });
    }
  }, [kycTrack]);

  const handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    if (name === "panNumber") {
      // Block spaces & special characters live
      value = value.toUpperCase().replace(/[^A-Z0-9]/g, "");
      setPanNumber(value);

      // Validation rules
      if (!value || value.trim().length === 0) {
        setPanNumberError("This field is required");
        return;
      }

      if (value.length !== 10) {
        setPanNumberError("PAN must be exactly 10 characters (ABCDE1234F)");
        return;
      }

      const regex = /^([A-Z]{5})([0-9]{4})([A-Z]{1})$/;
      if (!regex.test(value)) {
        setPanNumberError(
          "Invalid format. Format: First 5 letters, next 4 digits, last letter (e.g., ABCDE1234F)"
        );
        return;
      }

      setPanNumberError(""); // ✅ No error
    }

    if (name === "panImage") {
      const file = e.target.files[0];
      const error = ImageValidation("Pan card", file);
      setPancardImageError(error);
      file
        ? setPancardImageShow(URL.createObjectURL(file))
        : setPancardImageShow("");
      setPancardImage(file);
    }
  };

  const handleSubmit = async () => {
    // 🚨 Stop if PAN has errors
    if (panNumberError) return;
    setBtnDisable(true);
    setTimeout(() => setBtnDisable(false), 3000);

    // 🚨 Stop if PAN is still empty
    if (!panNumber || panNumber.trim().length === 0 || !pancardImage) {
      setPanNumberError(
        !panNumber || panNumber.trim().length === 0
          ? "This field is required"
          : ""
      );
      setPancardImageError(!pancardImage ? "This field is required" : "");
      return;
    }

    const imageError = ImageValidation("Pan card", pancardImage);
    setPancardImageError(imageError);
    if (imageError) return;

    // API call
    setBtnDisable(true);
    const formData = new FormData();
    formData.append("pan_number", panNumber);
    formData.append("pan_image", pancardImage);

    toast.dismiss();
    try {
      const { data, error } = await kycPanVerify(formData);
      if (error) {
        console.log("KYC PAN verify error:", error);
        const errMsg =
          error?.data?.message || error?.data?.error || "Something went wrong";
        toast.error(errMsg);
        return;
      }
      if (data.status) {
        toast.success(data.message || "Submitted successfully");
        refetch();
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setTimeout(() => setBtnDisable(false), 2000);
    }
  };

  return (
    <>
      <div className="pan-outer">
        <div className="">
          {/* <div className="col-md-3 col-12"></div> */}
          <div className="">
            <div className="white_box">
              <h6 className="position-relative">PAN Card Verification</h6>
              <b className="mt-0">Requirements</b>
              <ul className="dit_ul mb-4">
                <li>
                  The photo/scan must be clear, in color and uncompressed.
                </li>
                <li>The photo/scan must be not edited and not cropped.</li>
                {/* <li>
                  The document must be valid at least 3 months after the
                  verification submission date.
                </li> */}
                <li>
                  The full name and date of birth you provided in the "Personal
                  information" section{" "}
                </li>
                <li>should exactly match the ones in your document.</li>
                <li>Min size 10 Kb / Max size 2 Mb.</li>
              </ul>
              <div className="row">
                <div className="form-group col-md-6 col-12">
                  <label>PAN Card Number</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter PAN Card Number"
                    name="panNumber"
                    value={panNumber}
                    onChange={handleChange}
                    disabled={!isEditable}
                  />
                  {panNumberError && (
                    <div className="text-danger">{panNumberError}</div>
                  )}
                </div>
                <div className="form-group col-md-6 col-12">
                  <div id="file-upload-form" className="uploader">
                    <input
                      type="file"
                      id="file-upload3"
                      name="panImage"
                      accept="image/*"
                      onChange={handleChange}
                      disabled={!isEditable}
                    />
                    <label htmlFor="file-upload3" id="file-drag">
                      <img
                        src={pancardImageShow !== "" ? pancardImageShow : image}
                        className="img-fluid22"
                        alt="Identity"
                      />
                      <div id="start">
                        <span className="fasi"></span>
                        <div>Upload PAN Card Image</div>
                        <div id="notimage" className="hidden">
                          Please select an image
                        </div>
                      </div>
                      <div id="response" className="hidden">
                        <div id="messages"></div>
                        <progress
                          className="progress"
                          id="file-progress"
                          value="0"
                        >
                          <span>0</span>%
                        </progress>
                      </div>
                    </label>
                  </div>
                  <p className="mt-0">
                    *Only jpeg, jpg & png files supported
                    <br />
                    *For changing image, click on image upload section again.{" "}
                  </p>
                  {pancardImageError && (
                    <div className="text-danger">{pancardImageError}</div>
                  )}
                </div>
              </div>
              <Rejectreason reason={rejectionReason} status={panImageStatus} />
              {isEditable && (
                <button
                  className="btn btn_man w100px"
                  onClick={handleSubmit}
                  disabled={btnDisable}
                >
                  {status === "pending" ? "Submit" : "Re-submit"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Pancard;
